import { useContext } from "react";
import NavigationContext, { RouteParamsContext } from "../context/navigation";

function useNavigation() {
    return useContext(NavigationContext);
}

export function useRouteParams() {
    return useContext(RouteParamsContext);
}

export default useNavigation;